"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var CategoryDefaultSetting = function CategoryDefaultSetting(_ref) {
  var collapsed = _ref.collapsed,
      _onChange = _ref.onChange;
  var categorySettingOptions = ['Show all categories', (0, _preact.h)("p", {
    key: "cetagory-setting-collapse"
  }, "Collapse all categories - ", (0, _preact.h)("i", null, "Recommended if you have many (parent) categories."))];
  var categoryOn = categorySettingOptions[0],
      categoryOff = categorySettingOptions[1];
  return (0, _preact.h)("div", {
    className: "homepage-category-setting"
  }, (0, _preact.h)(_RadioInputGroup.default, {
    title: "Category list default setting",
    meta: "Define how users will see the category list upon their first visit.",
    options: categorySettingOptions,
    onChange: function onChange(e) {
      _onChange(e === categoryOff);
    },
    value: collapsed ? categoryOff : categoryOn
  }));
};

var _default = CategoryDefaultSetting;
exports.default = _default;